"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.performSubstitution = exports.SUBSTITUTION_FUNCTION_DELIMITER = exports.unifyEndOfLineCharacters = void 0;
const financial_date_1 = require("./financial-date");
function unifyEndOfLineCharacters(text) {
    return text.replace(/\r\n|\r|\n/g, '\n');
}
exports.unifyEndOfLineCharacters = unifyEndOfLineCharacters;
exports.SUBSTITUTION_FUNCTION_DELIMITER = '|';
class SubstitutionOperationDefs {
    constructor() {
        this.OPERATING_DATE = 'OPERATING_DATE';
    }
}
class SubstitutionVariableDefs {
}
;
const SUBSTITUTION_LOGIC = {
    'OPERATING_DATE': (inputs, context) => {
        if (inputs.length > 0) {
            const daysToAdd = Number.parseInt(inputs[0]);
            return financial_date_1.FinancialDate.fromString(context['OPERATING_DATE']).addDays(daysToAdd).getDateString();
        }
        else {
            return context['OPERATING_DATE'];
        }
    },
};
function performSubstitution(input, context, options) {
    let output = input;
    const blockCaptureRegex = /\${([-*\d|\w|\|]*)}/g;
    let match = blockCaptureRegex.exec(input);
    while (match != null) {
        const block = match[1];
        const splits = block.split(exports.SUBSTITUTION_FUNCTION_DELIMITER);
        if (Object.keys(new SubstitutionOperationDefs()).includes(splits[0])) {
            const operation = splits[0];
            const logic = SUBSTITUTION_LOGIC[operation];
            if (logic) {
                const result = logic(splits.slice(1), context);
                if (!result) {
                    if (options && options['ErrorOnFail']) {
                        throw new Error(`Failed to perform substitution on input: ${input} for logic: ${logic} with context: ${JSON.stringify(context)}`);
                    }
                }
                else {
                    output = output.replace(`\${${block}}`, result);
                }
            }
        }
        match = blockCaptureRegex.exec(input);
    }
    return output;
}
exports.performSubstitution = performSubstitution;
// console.log('===>' + performSubstitution('1001,${OPERATING_DATE},USD,${OPERATING_DATE|2}', { OPERATING_DATE: '2019-01-01' }, { ErrorOnFail: true }));
//# sourceMappingURL=substitution-utils.js.map